// src/Login.js - Local Harquil Font File Version
import React, { useState } from "react";
import { database, ref, get } from "./firebase";

// Make sure to download the Harquil font file and place it in your public/fonts/ folder
// Download from: https://fonts.cdnfonts.com/css/harquil

export default function Login({ onLogin }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!phone.match(/^\d{10}$/)) {
      alert("Enter valid 10-digit number");
      return;
    }

    setLoading(true);

    try {
      const userRef = ref(database, `users/${phone}`);
      const snap = await get(userRef);

      if (!snap.exists()) {
        alert("This number is not registered");
        setLoading(false);
        return;
      }

      const data = snap.val();

      if (!data.password) {
        alert("Password not set for this user. Please contact the owner.");
        setLoading(false);
        return;
      }

      if (data.password !== password) {
        alert("Incorrect password");
        setLoading(false);
        return;
      }

      const role = data.role;
      const name = data.name || phone;

      localStorage.setItem("role", role);
      localStorage.setItem("phone", phone);
      localStorage.setItem("name", name);

      onLogin({ phone, role, name });
    } catch (error) {
      alert("Login error. Please try again.");
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="login-container">
      <style>{`
        /* Local Harquil Font */
        @font-face {
          font-family: 'Harquil';
          src: url('/fonts/harquil.woff2') format('woff2'),
               url('/fonts/harquil.woff') format('woff'),
               url('/fonts/harquil.ttf') format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          -webkit-tap-highlight-color: transparent;
        }

        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }

        .login-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #ffb6c1 0%, #ff69b4 100%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 20px;
          position: relative;
          overflow: hidden;
        }

        .login-container::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
          animation: rotate 20s linear infinite;
          pointer-events: none;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .logo-card {
          text-align: center;
          margin-bottom: 40px;
          position: relative;
          z-index: 1;
        }

        /* Harquil Font Only - No fallbacks */
        .brand-name {
          font-family: 'Harquil', cursive;
          font-size: 5rem;
          background: linear-gradient(135deg, #fff 0%, #ffe4e1 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
          margin-bottom: 8px;
          animation: fadeInDown 0.6s ease;
          font-weight: normal;
          letter-spacing: 2px;
        }

        .tagline {
          color: rgba(255,255,255,0.95);
          font-size: 0.85rem;
          letter-spacing: 3px;
          animation: fadeInUp 0.6s ease;
          font-weight: 500;
        }

        .login-card {
          background: rgba(255, 255, 255, 0.98);
          border-radius: 32px;
          padding: 32px 24px;
          width: 100%;
          max-width: 380px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
          position: relative;
          z-index: 1;
          animation: fadeIn 0.5s ease;
        }

        .login-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          text-align: center;
          margin-bottom: 8px;
        }

        .login-subtitle {
          font-size: 0.8rem;
          color: #94a3b8;
          text-align: center;
          margin-bottom: 28px;
        }

        .input-group {
          margin-bottom: 20px;
        }

        .input-label {
          display: block;
          font-size: 0.75rem;
          font-weight: 600;
          color: #ff69b4;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .input-icon {
          position: relative;
        }

        .input-icon span {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 1.1rem;
        }

        .login-input {
          width: 100%;
          padding: 14px 14px 14px 48px;
          border: 2px solid #ffe4e1;
          border-radius: 28px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: white;
        }

        .login-input:focus {
          outline: none;
          border-color: #ff69b4;
          box-shadow: 0 0 0 3px rgba(255,105,180,0.1);
        }

        .login-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(135deg, #ffb6c1, #f71485);
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 12px;
        }

        .login-btn:active {
          transform: scale(0.97);
        }

        .login-btn.loading {
          opacity: 0.8;
          cursor: not-allowed;
        }

        .spinner {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-right: 8px;
          vertical-align: middle;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .login-footer {
          margin-top: 40px;
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .footer-text {
          color: rgba(255,255,255,0.9);
          font-size: 0.7rem;
        }

        .footer-text strong {
          color: white;
          font-weight: 600;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 480px) {
          .brand-name {
            font-size: 3.5rem;
          }
          .login-card {
            padding: 28px 20px;
          }
          .login-input {
            padding: 12px 12px 12px 44px;
            font-size: 0.95rem;
          }
          .login-btn {
            padding: 14px;
          }
          .tagline {
            font-size: 0.7rem;
            letter-spacing: 2px;
          }
        }

        .login-input[type="tel"] {
          -moz-appearance: textfield;
        }
        .login-input[type="tel"]::-webkit-inner-spin-button,
        .login-input[type="tel"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      `}</style>

      {/* Logo Section with Harquil Font */}
      <div className="logo-card">
        <div className="brand-name">Jauhari</div>
      </div>

      {/* Login Card */}
      <div className="login-card">
        <div className="login-title">Welcome Back</div>
        <div className="login-subtitle">Login to access your account</div>

        <div className="input-group">
          <label className="input-label">Mobile Number</label>
          <div className="input-icon">
            <span>📱</span>
            <input
              type="tel"
              className="login-input"
              placeholder="Enter 10-digit number"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
              onKeyPress={handleKeyPress}
              maxLength="10"
            />
          </div>
        </div>

        <div className="input-group">
          <label className="input-label">Password</label>
          <div className="input-icon">
            <span>🔒</span>
            <input
              type="password"
              className="login-input"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
        </div>

        <button 
          className={`login-btn ${loading ? "loading" : ""}`} 
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner"></span>
              Logging in...
            </>
          ) : (
            "Login →"
          )}
        </button>
      </div>

      {/* Footer */}
      <div className="login-footer">
        <p className="footer-text">
          Powered by <strong>Jauhari WebTech</strong>
          <br />
          © 2026 All Rights Reserved.
        </p>
      </div>
    </div>
  );
}